import { checkPermission } from "@ROM/Permissions/utils";

export const canManageCustomTables = (user) => checkPermission(user, "custom-tables:manage");
export const canAccessCustomTablesInCompanyAdmin = (user) => canManageCustomTables(user);
